module.exports = __webpack_public_path__ + "static/media/paraco_group.d4558e8d.png";